<div class="marquee-container">
  <div class="marquee">
    This is a test system
  </div>
</div>
